module.exports = __webpack_public_path__ + "static/www/img/hu.e1f69ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video/hu.jpg
// module id = 399
// module chunks = 1